/**
 * BlockUIモジュール
 *
 * No.    日付          更新者    更新内容
 *   1    2021/08/30    大友      新規作成
 *
 * @summary データ
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import {Modal} from 'bootstrap';

const BlockUI = (function(){
    const blockUIId = 'modal-blockui';
    const blockHtml = `
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content panel-primary">
      <div class="modal-header panel-heading alert-primary d-none">
        <h4 class="modal-title"></h4>
      </div>
      <div class="modal-body">
        <div class="d-flex justify-content-center justify-content-start align-items-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="spinner-text ms-2"></div>
          <div class="spinner-border text-primary visually-hidden" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div class="modal-footer d-none">
        <button name="btnNo" type="button" class="btn btn-light border-dark">いいえ</button>
        <button name="btnYes" type="button" class="btn btn-primary">はい</button>
      </div>
    </div>
  </div>
`;
    /**
     * modal用Element
     */
    let modalElement = null;
    /**
     * Modalオブジェクト
     */
    let modal = null;

    /**
     * 初期化処理
     */
    let init = function(text){
        if (modal === null) {
            let element = document.getElementById(blockUIId);
            if (element === null) {
                modalElement = createElement();
                document.body.prepend(modalElement);
            } else {
                modalElement = element;
            }
            modal = new Modal(modalElement);

            modalElement.addEventListener('show.bs.modal', function(event) {
                // モーダルのzIndex取得
                const zIndexList = Array.from(
                        document
                        .querySelectorAll('.modal.fade.show'))
                        .map(modal => parseInt(document.defaultView.getComputedStyle(modal, null).zIndex),10);
                //console.log('zIndexList', zIndexList);
                if (zIndexList.length > 0) {
                    const maxZIndex = Math.max.apply(null, zIndexList);
                    modalElement.style.zIndex = maxZIndex + 100;

                    //console.log('modalElement.style.zIndex', modalElement.style.zIndex);
                }
            }, false);

            modalElement.addEventListener('hidden.bs.modal', function(event) {
                // 表示中のモーダルがまだ存在する場合、削除されるmodal-openクラス再追加
                if (document.querySelector('.modal.fade.in') !== null) {
                    document.body.classList.add('modal-open');
                }
            }, false);
        }

        // テキストセット
        setBlockUIText(text);
    };
    /**
     * Modal用Element生成
     */
    let createElement = function(){
        let div = document.createElement('div');

        div.setAttribute('class', 'modal fade');
        div.setAttribute('id', blockUIId);
        div.setAttribute('tabindex', -1);
        div.setAttribute('role', 'dialog');
        div.setAttribute('aria-labelledby', 'myModalLabel');
        div.setAttribute('aria-hidden', true);
        div.setAttribute('data-bs-keyboard', true);
        div.setAttribute('data-bs-backdrop', 'static');

        div.innerHTML = blockHtml;
        return div;
    };
    /**
     * BlockUI処理中テキスト
     */
    let setBlockUIText = function(text){
        if (typeof text !== 'string') {
            //console.log(typeof text, text);
            throw 'text が string ではありません。';
        }
        let spinnerText = modalElement.querySelector('.spinner-text');
        if (spinnerText === null) {
            throw '.spinner-text が 見つかりませんでした。';
        }
        spinnerText.textContent = text;
    };
    /**
     * BlockUI表示
     */
    let show = function(text = '処理中...'){
        init(text);
        modal.show();
    };
    /**
     * BlockUI非表示
     */
    let hide = function(){
        if (modal)
            modal.hide();
    };
    return {
        show: show,
        hide: hide,
    };
})();
export {BlockUI};

//class BlockUI { // eslint-disable-line no-unused-vars
//    get vars () {
//        return {
//            modalId: 'modal-blockui',
//            blockHtml: `
//  <div class="modal-dialog modal-dialog-centered">
//    <div class="modal-content panel-primary">
//      <div class="modal-header panel-heading alert-primary d-none">
//        <h4 class="modal-title"></h4>
//      </div>
//      <div class="modal-body">
//        <div class="d-flex justify-content-center justify-content-start align-items-center">
//          <div class="spinner-border text-primary" role="status">
//            <span class="visually-hidden">Loading...</span>
//          </div>
//          <div class="spinner-text ms-2"></div>
//          <div class="spinner-border text-primary visually-hidden" role="status">
//            <span class="visually-hidden">Loading...</span>
//          </div>
//        </div>
//      </div>
//      <div class="modal-footer d-none">
//        <button name="btnNo" type="button" class="btn btn-light border-dark">いいえ</button>
//        <button name="btnYes" type="button" class="btn btn-primary">はい</button>
//      </div>
//    </div>
//  </div>
//`
//        };
//    }
//    constructor (){
//        const blockUIHtml = `
//  <div class="modal-dialog modal-dialog-centered">
//    <div class="modal-content panel-primary">
//      <div class="modal-header panel-heading alert-primary d-none">
//        <h4 class="modal-title"></h4>
//      </div>
//      <div class="modal-body">
//        <div class="d-flex justify-content-center justify-content-start align-items-center">
//          <div class="spinner-border text-primary" role="status">
//            <span class="visually-hidden">Loading...</span>
//          </div>
//          <div class="spinner-text ms-2"></div>
//          <div class="spinner-border text-primary visually-hidden" role="status">
//            <span class="visually-hidden">Loading...</span>
//          </div>
//        </div>
//      </div>
//      <div class="modal-footer d-none">
//        <button name="btnNo" type="button" class="btn btn-light border-dark">いいえ</button>
//        <button name="btnYes" type="button" class="btn btn-primary">はい</button>
//      </div>
//    </div>
//  </div>
//`;
////        $(".modal.fade.show").each(function(idx){
////          zIndexList[idx] = $(this).css('z-index');
////        });
////        var zIndex = Math.max.apply(null,zIndexList);
//
//        // 重複を避ける為、ランダムなIDを生成
//        this.BlockUIId = 'blockui_' + Math.random().toString(36).slice(-10);
//
//        this.BlockUIDom = document.createElement('div');
//        this.BlockUIDom.setAttribute('class', 'modal dade');
//        this.BlockUIDom.setAttribute('id', this.BlockUIId);
//        this.BlockUIDom.setAttribute('tabindex', -1);
//        this.BlockUIDom.setAttribute('role', 'dialog');
//        this.BlockUIDom.setAttribute('aria-labelledby', 'myModalLabel');
//        this.BlockUIDom.setAttribute('aria-hidden', true);
//        this.BlockUIDom.setAttribute('data-bs-keyboard', true);
//        this.BlockUIDom.setAttribute('data-bs-backdrop', 'static');
//
//        this.BlockUIDom.innerHTML = blockUIHtml;
//
//        // モーダルの重なりを調整する
//        const me = this;
//        this.BlockUIDom.addEventListener('show.bs.modal', function(event) {
//            // モーダルのzIndex取得
//            const zIndexList = Array.from(
//                    document
//                    .querySelectorAll('.modal.fade.show'))
//                    .map(modal => parseInt(document.defaultView.getComputedStyle(modal, null).zIndex),10);
//            if (zIndexList.length > 0) {
//                const maxZIndex = Math.max.apply(null, zIndexList);
//                console.log(maxZIndex);
//                console.log(me.BlockUIDom);
//                me.BlockUIDom.style.zIndex = maxZIndex + 100;
//            }
////            const zIndex = Math.max.apply(null, Array.prototype.map.call(document.querySelectorAll('.modal.fade.show'), function(element) {
////                  return +document.defaultView.getComputedStyle(element, null).zIndex;
////                })) + 100;
////            console.log('zIndex:', zIndex);
////            //this.BlockUIDom.style.zIndex = zIndex;
//        }, false);
//
//        this.BlockUIDom.addEventListener('hidden.bs.modal', function(event) {
//            // 表示中のモーダルがまだ存在する場合、削除されるmodal-openクラス再追加
//            if (document.querySelector('.modal.fade.in') !== null) {
//                document.body.classList.add('modal-open');
//            }
//        });
//    }
////    modal () {
////        let modal = document.getElementById(this.vars. = value;)
////    }
////    show (text = '処理中...') {
////
////    }
//    blockUI (text, options = {}){
//
//        if (typeof this.BlockUI === 'undefined') {
//            this.BlockUI = new Modal(this.BlockUIDom);
//        }
//
//        if (typeof text !== 'undefined' && text !== '') {
//            let spinnerText = this.BlockUIDom.querySelector('.spinner-text');
//            spinnerText.textContent = text;
//        }
//
////        //const zIndex =
////
////        // 最前面のモーダルのzIndex取得
////        let zIndexList = [];
////        console.log('よんだ？');
////        let modals = document.querySelectorAll('.modal.fade.show');
////        console.log(modals);
////        document.querySelectorAll('.modal.fade.show').forEach(element => {
////            zIndexList.push(document.defaultView.getComputedStyle(element, null).zIndex);
////        });
////        let zIndexList = Array.from(
////                document
////                .querySelectorAll('.modal.fade.show'))
////                .map(modal => parseInt(document.defaultView.getComputedStyle(modal, null).zIndex),10);
////        if (zIndexList.length > 0) {
////            Math.max(zIndexList);
////            this.BlockUIDom.style;
////        }
////        console.log(zIndexList);
//
//        // 表示
//        this.BlockUI.show();
//    }
//    unblockUI (callback){
//        if (typeof callback === 'function') {
//            callback();
//        }
//        this.BlockUI.hide();
//    }
//}
